// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-notification__errors[data-v-765bbdf2]{padding:0 12px;color:#ff1744;font-size:12px;line-height:1;margin-top:5px;min-height:14px}.add-notification__editor--errors[data-v-765bbdf2]{border:2px solid #ff1744!important}", ""]);
// Exports
module.exports = exports;
